require([
	'jquery',
	'd3',
	'c3',
	'root/Base/Js/MbiMediaQuery'
], function(
	$,
	d3,
	c3,
	mbiMq
	) {

	'use strict';

	if ($('.section-marktpreise-overview').length) {

	// array includes polyfill
	if (!Array.prototype.includes) {
	  Array.prototype.includes = function(searchElement /*, fromIndex*/) {
	    'use strict';
	    if (this == null) {
	      throw new TypeError('Array.prototype.includes called on null or undefined');
	    }

	    var O = Object(this);
	    var len = parseInt(O.length, 10) || 0;
	    if (len === 0) {
	      return false;
	    }
	    var n = parseInt(arguments[1], 10) || 0;
	    var k;
	    if (n >= 0) {
	      k = n;
	    } else {
	      k = len + n;
	      if (k < 0) {k = 0;}
	    }
	    var currentElement;
	    while (k < len) {
	      currentElement = O[k];
	      if (searchElement === currentElement ||
	         (searchElement !== searchElement && currentElement !== currentElement)) { // NaN !== NaN
	        return true;
	      }
	      k++;
	    }
	    return false;
	  };
	}

		// GLOBAL VARS
		var countLoadMore = 0,
			$currentYear = $('.js_current-year'),
			currentYear = getYear($currentYear),
			activeYear = currentYear,
			prevYear = activeYear - 1,
			nextYear = activeYear + 1,
			lastYear = 2015,
			years = [activeYear, activeYear-1],
			maxWeeks = $('.table.is_active').attr('data-weeks'),
			$changeView = $('.js_table__change-view'),
			$loadYear = $('.js_table__load-year'),
			$tabs = $('.tab'),
			$tables = $('.table-wrapper'),
			view = 'table';

		var marktpreise = [];
		marktpreise[prevYear] = getJson(prevYear);
		marktpreise[currentYear] = getJson(currentYear);

		var categories = {
			activeCategory: false
		};


		function setCategory(category) {
			$('html').attr('data-category', category);
		}

		function getCategory() {
			return $('html').attr('data-category');
		}

		function setChartColors(year, prev) {
			var colors = {};

			if (prev) {
				colors['mastschweine'+year] = '#444444';
				colors['zuchten'+year] = '#444444';
				colors['ferkel'+year] = '#444444';
			} else {
				colors['mastschweine'+year] = '#3ca07c';
				colors['zuchten'+year] = '#e79b83';
				colors['ferkel'+year] = '#2886c3';
			}

			return colors;
		}


		function jsonReviewer(key, value) {
			if (typeof(value) === 'object') {

				for (var i = 0; i < value.length; i++) {
					if (value[i] == 0) {
						value[i] = null;
					}
				}

				return value;

			} else {

				return value

			}
		}


		function getJson(year) {

			var rawData,
				rawDataPrev,
				jsonData,
				jsonDataPrev;


			if (year === currentYear) {

				// CURRENT YEAR
				var rawData = $('.table[data-year=' + currentYear + ']').attr('data-json');
				rawData = rawData.replace('mastschweine', 'mastschweine'+currentYear);
				rawData = rawData.replace('zuchten', 'zuchten'+currentYear);
				rawData = rawData.replace('ferkel', 'ferkel'+currentYear);
				var jsonData = JSON.parse(rawData, jsonReviewer);

				// additional
				var additionalWeeks = {};
					additionalWeeks['kw'] = [jsonData.kw.length+1];
					additionalWeeks['mastschweine'+currentYear] = [null];
					additionalWeeks['zuchten'+currentYear] = [null];
					additionalWeeks['ferkel'+currentYear] = [null];

				for (var i = jsonData.kw.length+2; i <= 52; i++) {
					additionalWeeks['kw'].push(i);
					additionalWeeks['mastschweine'+currentYear].push(null);
					additionalWeeks['zuchten'+currentYear].push(null);
					additionalWeeks['ferkel'+currentYear].push(null);
				}

				for (var prop in jsonData) {
					jsonData[prop] = additionalWeeks[prop].concat(jsonData[prop]);
				}

			} else {

				rawData = $('.table[data-year=' + year + ']').attr('data-json');
				rawData = rawData.replace('mastschweine', 'mastschweine' + year);
				rawData = rawData.replace('zuchten', 'zuchten' + year);
				rawData = rawData.replace('ferkel', 'ferkel' + year);

				var jsonData = JSON.parse(rawData, jsonReviewer);
			}

			return jsonData;

		}

		function getWeeks(year){
		    var weeks = [],
		    	value = null,
				months = ['JÄN', 'FEB', 'MÄR', 'APR', 'MAI', 'JUN', 'JUL', 'AUG', 'SEP', 'OKT', 'NOV', 'DEZ'],
		    	oldMonth = 0,
		    	offset = 1;

			    weeks.push({value: 1, text: 'JÄN', class: 'c3-month'});

			    for (var i = 2; i <= 51; i++) {
			    	var d = new Date("Jan 01, "+year+" 01:00:00");
			    	var w = d.getTime() + 604800000 * (i-1); // week in ms
			    	var n1 = new Date(w);
			    	var n2 = new Date(w + 518400000);
			    	var newMonth1 = n1.getMonth();
			    	var newMonth2 = n2.getMonth();

			    	if (newMonth1 === oldMonth || newMonth2 === oldMonth) {
			    		value = {value: i};
			    	} else {
			    		value = {value: i, text: months[offset++], class: 'c3-month'};
			    		oldMonth++;
			    	}

			    	weeks.push(value);
			    }

			    weeks.push({value: 52, class: 'c3-month'});

		    return weeks;

		}




		// GRAPH


		var chart = c3.generate({
		    bindto: '#chart',
		    size: {
		    	height: 500
		    },
		    data: {
				x: 'kw',
				json: marktpreise[activeYear],
				colors: setChartColors(currentYear),
				selection: {
					enabled: true
				}
			},
		    axis : {
		        x: {
		        	min: 1,
		        	max: 52,
		        	outer: false,
		        	type: 'indexed',
		        	tick: {
		        		centered: true,
		        		culling: false,
		        		format: function(x) { return x; }
		        	}
		        },
		        y: {
		            min: 1.0,
		            max: 4.0,
		            tick: {
		                format: function (value) {
		                	return value.toLocaleString("de-DE", {minimumFractionDigits: 1}) + ' €';
		                }
		            }
		        }
		    },
		    grid: {
			    x: {
			        show: false,
			        lines: getWeeks(currentYear)
			    },
				tooltip: {
					show: false
				},
				legend: {
					show: false
				}
			},
			zoom: {
				enabled: false
			},
			point: {
				r: 3,
				focus: {
					expand: {
						r: 5
					}
				}
			},
//
			tooltip: {
				grouped: true,
				format: {
					title: function(x) { return 'KW' + x; },
					name: function (name, ratio, id, index) {

						var year = name.slice(-4),
							category = name.replace(year, '');
							category = category.charAt(0).toUpperCase() + category.slice(1)

						if (categories.activeCategory) {
							return year;
						} else {
							return category;
						}
					},
					value: function (value, ratio, id, index) {
						return value.toLocaleString("de-DE", {minimumFractionDigits: 2}) + '€';
					}
				},
			},
			legend: {
				show: false
			}
		});

		setTimeout(function(){
			chart.load({
				json: marktpreise[prevYear],
				colors: setChartColors(prevYear, true),

				done: function(){
					chart.hide(['mastschweine'+prevYear, 'zuchten'+prevYear, 'ferkel'+prevYear]);
				}
			});
		}, 100);


		function updateChart(year, action) {
			// console.log(year, action);
			var unloadYear,
				loadYear,
				showYear,
				dataToShow,
				dataToHide = ['mastschweine'+(year-1), 'zuchten'+(year-1), 'ferkel'+(year-1)];

			if (categories.activeCategory) {
				dataToShow = [categories.activeCategory+year, categories.activeCategory+(year-1)];
			} else {
				dataToShow = ['mastschweine'+year, 'zuchten'+year, 'ferkel'+year];
			}

			if (action == 'prev') {
				loadYear = year-1;
				showYear = year;
				unloadYear = year+1;
			} else {
				unloadYear = year-2;
				showYear = year-1;
				loadYear = year;
			}


			if (loadYear >= lastYear) {
				chart.load({
					json: getJson(loadYear),
					colors: setChartColors(loadYear, true),
					unload: ['mastschweine'+unloadYear, 'zuchten'+unloadYear, 'ferkel'+unloadYear]
				});
			} else {
				chart.unload(['mastschweine'+unloadYear, 'zuchten'+unloadYear, 'ferkel'+unloadYear]);
			}

			// setTimeout(function(){

				chart.hide(dataToHide);
			// 	console.log('dataToHide: ');
			// 	console.log(dataToHide);

				chart.data.colors(setChartColors(year));
				chart.data.colors(setChartColors(year-1, true));

				chart.show(dataToShow);
			// 	console.log('dataToShow: ');
			// 	console.log(dataToShow);

			// }, 50);

			// setTimeout(function() {
			// 	console.log('chart.data:');
			// 	console.log(chart.data());
			// 	console.log('chart.data.shown:');
			// 	console.log(chart.data.shown());
			// },100);

				chart.xgrids(getWeeks(year));
		}


		function getYear($year) {
			return parseInt($year.attr('data-year'));
		}

		function setYear($year, year) {
			$year.attr('data-year', parseInt(year));
		}

		function setActiveView($view) {
			if (!$view.hasClass('is_active')) {
				$changeView.toggleClass('is_active');
				$tabs.toggleClass('is_active');
				view = $view.attr('data-view');
			}
		}

		function showMore(e, maxLoads, minItems) {
			var dataYear = e.parents('.table').attr('data-year'),
				$hiddenItems = $('.section-marktpreise-overview .table[data-year='+dataYear+'] tr[hidden]');

			countLoadMore++;

			if (countLoadMore >= maxLoads || $hiddenItems.length <= minItems) {
				$hiddenItems.removeAttr("hidden");
				e.parent().attr('hidden', 'hidden');
				countLoadMore = 0;
			} else {
				$hiddenItems.slice(0,6).removeAttr("hidden");
			}
		}

		function loadYear(year, action) {
			var year_to_load = 0;
			if (!years.includes(year)) {
				years.push(year);
				year_to_load = year;
			}
			if (!years.includes(year-1)) {
				years.push(year-1);
				year_to_load = year-1;
			}
			if (year_to_load >= lastYear) {
				var data = {
					action: 'load_year',
					load: action,
					request_year: year_to_load
				};

				$.ajax({
					dataType: 	'json',
					data: 		data,
					timeout:	10000,
					error:		function() {
						console.log('error');
					},
					success: function(response) {

						// console.log('success');
						// console.log(response);
						$tables.append(response.html);
						updateChart(year, action);

					}
				});
			} else {
				updateChart(year, action);
			}
		}

		function updateTableTitle(year) {
			$('.controls__current-year--value').text(year);
			$('.graph-year_current__data').text(year);
			$('.graph-year_prev__data').text(year-1);
		}

		function updateLegendColor(category) {
			$('.graph-year_current, .graph-year_prev').attr('data-category', category);
		}

		function updateLegendAverage(year) {
			var $chartAverage = $('.graph-category__value'),
				$tableAverage = $('.table[data-year='+year+'] .table__average .table__average__value'),
				average = [],
				category = '';

			$tableAverage.each(function(){
				average[$(this).attr('data-category')] = $(this).text();
			});

			$chartAverage.each(function(){
				category = $(this).attr('data-category');
				$(this).text(average[category]);
			});

			$chartAverage.children('')
		}

		function updateControls(year) {
			$('.controls__next-year').attr('active', '');
			$('.controls__prev-year').attr('active', '');
			if (year === currentYear) {
				$('.controls__next-year').removeAttr('active');
			} else if (year === lastYear) {
				$('.controls__prev-year').removeAttr('active');
			}
		}

		function resizeChart(resize){
			if ('landscape-' in mbiMq.mqArea) {
				chart.resize({
					height: 400
				});
				chart.zoom.enable(true);
				chart.zoom([1,35]);
			} else if ('portrait-' in mbiMq.mqArea) {
				chart.resize({
					height: 300
				});
				chart.zoom([1,25]);
			} else if (resize) {
				chart.resize({
					height: 500
				});
				chart.unzoom();
				chart.zoom.enable(false);
			}
		}

		function checkView() {
			if ('lap-' in mbiMq.mqArea && view !== 'table') {
				$tabs.toggleClass('is_active');
				view = 'table';
			}
		}



		// LOAD MORE
		function loadMore() {
			return $('.js_table__load-more').click(function(e){
				e.preventDefault();
				e.stopPropagation();

				showMore($(this), 3, 10);
			});
		}


		// CATEGORY
		$('.js_controls__category-select').on('change', function(){
			var category = $(this).val();
			setCategory(category);
		});


		// NEXT/PREV YEAR
		$loadYear.click(function(e){
			e.preventDefault();
			e.stopPropagation();

			var year = getYear($(this)),
				action = $(this).attr('data-action');


			if (year >= lastYear && year <= currentYear) {
				if (action == 'prev') {
					activeYear--;
				} else if (action == 'next') {
					activeYear++;
				}

				setYear($currentYear, activeYear);

				$loadYear.each(function(){
					var newYear = getYear($(this));
					if (action == 'prev') {
						setYear($(this), newYear-1);
					} else if (action == 'next') {
						setYear($(this), newYear+1);
					}
				});

				loadYear(year, action);

				updateTableTitle(year);
				updateLegendAverage(year);
				updateControls(year);

				loadMore();

				$('.table').removeClass('is_active');
				$('.table[data-year=' + year + ']').addClass('is_active');

			}
		});


		$('.js_graph-category').click(function(){
			var category = $(this).attr('data-category');

			if ($(this).hasClass('is_selected')) {
				$('.graph-year').removeAttr('active');
				$('.js_graph-category').removeClass('is_selected');
				$('.js_graph-category').addClass('is_active');
				categories.activeCategory = false;

				chart.show(['mastschweine'+activeYear, 'zuchten'+activeYear, 'ferkel'+activeYear]);
				chart.hide(['mastschweine'+(activeYear-1), 'zuchten'+(activeYear-1), 'ferkel'+(activeYear-1)]);
			} else {
				$('.graph-year').attr('active', '');
				$('.js_graph-category').removeClass('is_active is_selected');
				updateLegendColor(category);
				categories.activeCategory = category;
				$('html').attr('data-category', category);
				chart.hide();
				$(this).addClass('is_active is_selected');
				chart.show([category+activeYear, category+(activeYear-1)]);
			}
		});


		$changeView.click(function(e){
			e.preventDefault();
			e.stopPropagation();

			setActiveView($(this));
		});


		loadMore();
		resizeChart();


		$(document).on('breakpoint', function(){
			resizeChart(true);
			checkView();
		});


	}
});
define("root/Assets/Templates/Html/MarktpreiseOverview/Js/MarktpreiseOverview", function(){});

